export default __webpack_public_path__ + "static/media/AcessosIconBlue.f4fdd12a.svg";